import { FormInstance } from "antd";
import { setTimeWithSeconds } from "../../helpers";
import { pickerValueFromUtc } from "@/components/timezone";

export const setExamPeriodFormValues = (
    groupSettingsForm: FormInstance,
    examPeriod: any,
    iana?: string | null
) => {
    const tempExamPeriod = {
        ...examPeriod
    }
    delete tempExamPeriod.time;
    delete tempExamPeriod.date;

    // groupSettingsForm.setFieldValue('type', "Online");
    
    groupSettingsForm.setFieldsValue(tempExamPeriod)
    
    if (examPeriod.time) {
      groupSettingsForm.setFieldsValue({
        time: setTimeWithSeconds(examPeriod.time),
        date: pickerValueFromUtc(examPeriod.date, iana)
      });
    }
}